import { formatDealDateRange } from "@escapio/portal/components/deals/get-description-template";

export const buildClickProfileLabel = (prefix, context, deal) =>
	`${prefix} - Klick Profil - ${context} - ${
		deal.hotel.id
	} - ${formatDealDateRange(deal)}`;
